import React, { useContext, useMemo, useState } from 'react';
import BreakDownHeader from '@/pages/dashboard/components/BreakDownHeader';
import { getLocale, useIntl } from 'umi';
import './index.scss'
import { CountriesContextTabProps } from '../_type';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { FilterContextType } from '@/pages/dashboard/components/PageContainer/type';


const CountriesContextTab = (props: CountriesContextTabProps) => {
  const { children, ...resetProps } = props || {}

  const contextObj = useContext(FilterContext)
  const { filterVal, filterLoading } = contextObj || {};

  const { formatMessage } = useIntl(); // 中英切换方法
  const isEN = getLocale() === 'en-US';
  const [tabsVal, setTabsVal] = useState('os');

  const options = useMemo(() => {
    return [
      { text: formatMessage({ id: 'common_System' }), value: 'os' },
      { text: formatMessage({ id: 'common_Country' }), value: 'country' },
      { text: formatMessage({ id: 'common_Region' }), value: 'region' },
    ]
  }, [isEN])

  
  return (
    <div className='dbd-countries-context-box'>
      <BreakDownHeader options={options}
        defaultValue='os'
        onChange={(val: string) => setTabsVal(val)}
      />
      {
        // 保证是jsx数组，而不是其他类型数组
        React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              filterVal,
              filterLoading,
              state: { regionDataType: tabsVal }
            }
          );
        })
      }
    </div>
  );
};

export default CountriesContextTab;
